const StandardAttributeConstants = {
  ADDORUPDATE_STANDARD_ATTRIBUTE_SUCCESS:
    "ADDORUPDATE_STANDARD_ATTRIBUTE_SUCCESS",
  ADDORUPDATE_STANDARD_ATTRIBUTE_FAILURE:
    "ADDORUPDATE_STANDARD_ATTRIBUTE_FAILURE",
  GET_QUERY_LIST_SUCCESS: "GET_QUERY_LIST_SUCCESS",
  GET_QUERY_LIST_FAILURE: "GET_QUERY_LIST_FAILURE",
  GET_StandardAttribute_SUCCESS: "GET_StandardAttribute_SUCCESS",
  GET_StandardAttribute_FAILURE: "GET_StandardAttribute_FAILURE",
  DELETE_ATTRIBUTE_SUCCESS: "DELETE_ATTRIBUTE_SUCCESS",
  DELETE_ATTRIBUTE_FAILURE: "DELETE_ATTRIBUTE_FAILURE",
  GET_ATTRIBUTE_TYPE_SUCCESS: "GET_ATTRIBUTE_TYPE_SUCCESS",
  GET_ATTRIBUTE_TYPE_FAILURE: "GET_ATTRIBUTE_TYPE_FAILURE",
  GET_ATTRIBUTE_OPTIONS_SUCCESS: "GET_ATTRIBUTE_OPTIONS_SUCCESS",
  GET_ATTRIBUTE_OPTIONS_FAILURE: "GET_ATTRIBUTE_OPTIONS_FAILURE",
  SAVE_UPDATE_WERK_ATTRIBUTE_OPTIONS_SUCCESS:
    "SAVE_UPDATE_WERK_ATTRIBUTE_OPTIONS_SUCCESS",
  SAVE_UPDATE_WERK_ATTRIBUTE_OPTIONS_FAILURE:
    "SAVE_UPDATE_WERK_ATTRIBUTE_OPTIONS_FAILURE",
  GET_STANDARD_ATTRIBUTE_OPTIONS_SUCCESS:
    "GET_STANDARD_ATTRIBUTE_OPTIONS_SUCCESS",
  GET_STANDARD_ATTRIBUTE_OPTIONS_FAILURE:
    "GET_STANDARD_ATTRIBUTE_OPTIONS_FAILURE",
  GET_QUERY_DATA_RESULT_SUCCESS: "GET_QUERY_DATA_RESULT_SUCCESS",
  GET_QUERY_DATA_RESULT_FAILURE: "GET_QUERY_DATA_RESULT_FAILURE",
};

export default StandardAttributeConstants;
